import React from "react";
import ZylaLogo from "../assets/images/zyla-logo-circular.png";
import "./ZylaBanner.css";
const ZylaBanner = () => {
  return (
    <div className="zyla-banner-container">
      <div className="zyla-banner-container-upper-div">
        <div className="zyla-banner-container-upper-div-top">
          <span className="zyla-banner-container-upper-div-top-span">
            References:
          </span>
          <ul className="zyla-banner-container-upper-div-top-ul">
            <li>
              10-year risk of developing type-2 diabetes is based on FINDRISC
              score (Finnish Diabetes Risk Score). FINDRISC score has been
              extensively validated across numerous studies on predicting the
              probability of developing undiagnosed T2DM.
            </li>
            <li>
              10-year risk of developing a cardio-vascular disease (CVD) is
              based on Framingham Heart Study. Over 3,000 peer-reviewed
              scientific papers have been published related to the Framingham
              Heart Study.
            </li>
            <li>
              Your 4-year risk (near-term risk) of developing hypertension and
              Fatty liver disease risk is based on the Framingham Heart Study,
              Massachusetts.
            </li>
          </ul>
        </div>
        <div className="zyla-banner-container-upper-div-bottom">
          <span className="zyla-banner-container-upper-div-bottom-span-one">
            Disclaimer:
          </span>
          <span className="zyla-banner-container-upper-div-bottom-span-two">
            The health risk analysis is solely based on the self-reported
            answers provided by the user. The medical data has not been
            triangulated via reports or physical examination. The user is solely
            responsible for the accuracy of the responses which directly impacts
            the risk score.
          </span>
        </div>
      </div>
      <div className="zyla-banner-lower-div">
        <div className="zyla-banner-lower-div-left">
          <img src={ZylaLogo} />
          <div>
            <span>Your personal</span>
            <span>healthcare expert</span>
          </div>
        </div>
        <div className="zyla-banner-lower-div-right">
          In case of any query write to us at: care@zyla.in
        </div>
      </div>
    </div>
  );
};

export default ZylaBanner;
